import { useQuery } from '@tanstack/react-query';
import { sessionApi } from '@/api/endpoints/session';
import { ApiError } from '@/api/client';
import { useSessionStore } from '@/stores/session';
import { useEffect } from 'react';

export function useSession() {
  const setUser = useSessionStore((s) => s.setUser);

  const query = useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      try {
        return await sessionApi.current();
      } catch (err) {
        if (err instanceof ApiError && (err.status === 404 || err.status === 401)) {
          return null;
        }
        throw err;
      }
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    setUser(query.data ?? null);
  }, [query.data, setUser]);

  return query;
}
